import React from 'react';
import HeaderImage from "../assets/bank-assets/dossier.jpg"; //TODO: change this.
import { useTranslation } from "react-i18next";


function Dossier(props) {
    const { t, i18n } = useTranslation();

    return (
        <>
            {i18n.language === "fr" ? (
                <div className="flex flex-col items-center w-screen px-4">
                    <div className="justify-center my-10">
                        <h2 className="text-3xl  text-primery-color text-center mb-10 font-semibold">
                            Dossier à fournir
                        </h2>
                        <img alt={"..."} className="w-128 rounded-2xl" src={HeaderImage} />
                    </div>
                    <div className="justify-center my-10">
                        <div className="items-center mx-8 lg:mx-2 text-left max-w-3xl ">
                            <h6 className="text-lg font-semibold  mb-5 font-meduim">
                                Les Salariés
                            </h6>
                            <ul className="list-disc">
                                <li>Le formulaire de demande de financement dûment rempli et signé par le bénéficiaire</li>
                                <li>La photocopie de la Carte Nationale d’Identité ou du Permis de Conduire en cours de
                                    validité
                                </li>
                                <li>Un acte de naissance</li>
                                <li>Un justificatif de résidence datant de moins de trois (3) mois</li>
                                <li>Une attestation de travail</li>
                                <li>Les trois (03) derniers contrats de travail pour les contractuels</li>
                                <li>Les trois (03) dernières fiches de paie pour les salariés</li>
                                <li>Une attestation de revenu (pension de retraite) délivrée par la CNR, pour les retraités</li>
                                <li>Le relevé des émoluments du bénéficiaire</li>
                                <li>La copie de la carte d’immatriculation de la sécurité sociale</li>
                                <li>Une attestation sur l’honneur de non endettement ou indiquant le montant des dettes déjà
                                    contractées
                                </li>
                                <li>Une facture pro-forma du bien à la consommation établie au nom de la Banque pour le compte
                                    du client accompagnée d’une attestation délivrée par le fournisseur attestant que le bien
                                    objet de la demande de financement est produit ou assemblé en Algérie.
                                </li>
                            </ul>
                        </div>
                        <div className="items-center mt-10 mx-8 lg:mx-2 text-left max-w-3xl">
                            <h6 className="text-lg font-semibold  mb-5 font-meduim">
                                Les Professionnels
                            </h6>
                            <ul className="list-disc">
                                <li>Le formulaire de demande de financement dûment rempli et signé par le bénéficiaire</li>
                                <li>La photocopie de la Carte Nationale d’Identité ou du Permis de Conduire en cours de
                                    validité
                                </li>
                                <li>Un acte de naissance</li>
                                <li>Un justificatif de résidence datant de moins de trois (3) mois</li>
                                <li>Un agrément délivré par l’autorité compétente, pour les fonctions libérales</li>
                                <li> L’inscription au tableau du conseil de l’ordre concerné</li>
                                <li> La copie du Registre du Commerce, s’il y a lieu</li>
                                <li> La déclaration annuelle des revenus des deux derniers exercices précédents</li>
                                <li> Un extrait de rôle apuré daté moins de 03 mois</li>
                                <li>Une attestation de mise à jour envers les assurances sociales</li>
                                <li>Une attestation sur l’honneur de non endettement ou indiquant le montant des dettes déjà
                                    contractées
                                </li>
                                <li>Une facture pro-forma du bien à la consommation établie au nom de la Banque pour le compte
                                    du bénéficiaire accompagnée d’une attestation délivrée par le fournisseur attestant que le
                                    bien objet de la demande de financement est produit ou assemblé en Algérie
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            ) : (<div className="flex flex-col items-center w-screen px-4">
                <div className="justify-center my-10">
                    <h2 className="text-3xl  text-primery-color text-center mb-10 font-semibold">
                        الملف المطلوب
                    </h2>
                    <img alt={"..."} className="w-128 rounded-2xl" src={HeaderImage} />
                </div>
                <div className="justify-center my-10">
                    <div className="items-center text-right max-w-3xl">
                        <h6 className="text-lg font-semibold  mb-5 font-meduim">
                            الموظفون
                        </h6>
                        <ul>
                            <li>استمارة طلب التمويل معبأة حسب المطلوب وموقعة من المستفيد ○</li>
                            <li>نسخة من بطاقة الهوية الوطنية أو رخصة القيادة سارية المفعول ○</li>
                            <li>عقد الازدياد ○</li>
                            <li>إثبات الإقامة لمدّة تقل عن ثلاثة (3) أشهر ○</li>
                            <li>شهادة عمل ○</li>
                            <li>آخر ثلاثة (03) عقود عمل للعاملين بعقود ○</li>
                            <li>آخر ثلاث (03) كشوف راتب للموظفين ○</li>
                            <li> شهادة دخل (معاش تقاعدي) صادرة عن اللجنة الوطنية لشؤون المتقاعدين، للمتقاعدين ○</li>
                            <li>شهادة بمكافآت المستحق ○</li>
                            <li> نسخة من بطاقة التسجيل في الضمان الاجتماعي ○</li>
                            <li> شهادة تأكيد بعدم المديونية أو توضح مقدار الديون المتعاقد عليها ○</li>
                            <li>فاتورة مبدئية للسلعة الاستهلاكية مسجلة باسم البنك نيابة عن العميل مصحوبة بشهادة صادرة عن المورد تثبت أن موضوع طلب التمويل قد تم إنتاجه أو تجميعه في الجزائر ○</li>
                        </ul>
                    </div>
                    <div className="items-center mt-10 text-right max-w-3xl">
                        <h6 className="text-lg font-semibold  mb-5 font-meduim">
                            المهنيين
                        </h6>
                        <ul>
                            <li>استمارة طلب التمويل معبأة حسب المطلوب وموقعة من المستفيد ○</li>
                            <li>نسخة من بطاقة الهوية الوطنية أو رخصة القيادة سارية المفعول ○</li>
                            <li>عقد الازدياد ○</li>
                            <li> إثبات محل الإقامة لمدة تقل عن ثلاثة (03) أشهر ○</li>
                            <li> إذن صادر عن السلطة المختصة لوظائف حرة ○</li>
                            <li>  التسجيل في مجلس نقابة المحامين المعنية ○</li>
                            <li> نسخة من السجل التجاري، إن وجد ○</li>
                            <li>الإقرار السنوي عن الدخل لآخر سنتين سابقتين ○</li>
                            <li> كشف ضريبي منذ أقل من 03 شهرًا ○</li>
                            <li>شهادة تحديث التأمين الاجتماعي ○</li>
                            <li>شهادة تأكيد بعدم المديونية أو توضح مقدار الديون المتعاقد عليها ○</li>
                            <li>فاتورة مبدئية للسلعة الاستهلاكية تُنشأ باسم البنك نيابة عن المستفيد مصحوبة بشهادة صادرة عن المورد تثبت أن موضوع طلب التمويل قد تم إنتاجه أو تجميعه في الجزائر ○</li>
                        </ul>
                    </div>
                </div>
            </div>)}

        </>
    );
}

export default Dossier;